import Login from "./login-component";

export default Login